import React, { useEffect, useState, useRef, useCallback } from 'react';
import {
    FilterBarContainer,
    FilterBarLeftContent,
    FilterBarRightContent,
    SearchContainer,
} from "./Filters.styled";
import { Button, TextField, SwitchMode } from "@ann/web-components";
import { useDrivesStores } from '../../../../hook/use-drives.hook';

const Filters = ({ 
    mode, 
    setMode, 
    onFilterChange,
    filterText = ""
}) => {
    const { drivesViewStore } = useDrivesStores();
    const [searchValue, setSearchValue] = useState(filterText);
    const searchTimeoutRef = useRef(null);

    // Sync local state with prop when it changes
    useEffect(() => {
        setSearchValue(filterText);
    }, [filterText]);

    const handleSearchChange = useCallback((value) => {
        setSearchValue(value);
        
        // Clear existing timeout
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        
        // Set new timeout for 500ms debounce
        searchTimeoutRef.current = setTimeout(() => {
            if (onFilterChange) {
                onFilterChange(value);
            }
        }, 500);
    }, [onFilterChange]);

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);

    const handleClearAllFilters = () => {
        setSearchValue("");
        
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        
        if (onFilterChange) {
            onFilterChange("");
        }
    };

    const hasActiveFilters = searchValue.trim() !== "";

    return (
        <FilterBarContainer>
            <FilterBarLeftContent>
                <SearchContainer>
                    <TextField
                        iconLeft="search"
                        onChange={handleSearchChange}
                        size="small"
                        placeholder="Search"
                        value={searchValue}
                    />
                </SearchContainer>

                {hasActiveFilters && (
                    <Button
                        icon=""
                        icuonLeft=""
                        iconRight=""
                        label="Clear Filters"
                        size="medium"
                        type="secondary"
                        onClick={handleClearAllFilters}
                    />
                )}
            </FilterBarLeftContent>

            <FilterBarRightContent>
              
            </FilterBarRightContent>
        </FilterBarContainer>
    );
};

export default Filters;
